module.exports = __webpack_public_path__ + "static/FSDG-2-b64cb5af1b6ad2a182dd6035aed4516b.jpg";